export default __webpack_public_path__ + "static/media/title_ko_pc.e3cfaa47.png";